<template>
    <MyRecords />
</template>

<script>
import MyRecords from './appointment/pages/MyRecords';

export default {
    components: {
        MyRecords
    }
    
};
</script>

<style lang="scss" scoped>

</style>